import { render, staticRenderFns } from "./siteAdminGroupList.vue?vue&type=template&id=33fbe4d4&scoped=true&"
import script from "./siteAdminGroupList.vue?vue&type=script&lang=js&"
export * from "./siteAdminGroupList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fbe4d4",
  null
  
)

export default component.exports